/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';
import { AccountRecoveryService } from './services/AccountRecoveryService';
import { AdminService } from './services/AdminService';
import { AuthenticationService } from './services/AuthenticationService';
import { CompaniesService } from './services/CompaniesService';
import { CountriesService } from './services/CountriesService';
import { DefaultService } from './services/DefaultService';
import { FinancialDataService } from './services/FinancialDataService';
import { GraphDataService } from './services/GraphDataService';
import { HsCodesService } from './services/HsCodesService';
import { InvitationsService } from './services/InvitationsService';
import { PermissionsService } from './services/PermissionsService';
import { ProdcomService } from './services/ProdcomService';
import { PublicAccessService } from './services/PublicAccessService';
import { TradeService } from './services/TradeService';
import { TradeDataService } from './services/TradeDataService';
import { UserInvitationsService } from './services/UserInvitationsService';
import { ValueChainPermissionsService } from './services/ValueChainPermissionsService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class ApiClient {
    public readonly accountRecovery: AccountRecoveryService;
    public readonly admin: AdminService;
    public readonly authentication: AuthenticationService;
    public readonly companies: CompaniesService;
    public readonly countries: CountriesService;
    public readonly default: DefaultService;
    public readonly financialData: FinancialDataService;
    public readonly graphData: GraphDataService;
    public readonly hsCodes: HsCodesService;
    public readonly invitations: InvitationsService;
    public readonly permissions: PermissionsService;
    public readonly prodcom: ProdcomService;
    public readonly publicAccess: PublicAccessService;
    public readonly trade: TradeService;
    public readonly tradeData: TradeDataService;
    public readonly userInvitations: UserInvitationsService;
    public readonly valueChainPermissions: ValueChainPermissionsService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '1.0.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.accountRecovery = new AccountRecoveryService(this.request);
        this.admin = new AdminService(this.request);
        this.authentication = new AuthenticationService(this.request);
        this.companies = new CompaniesService(this.request);
        this.countries = new CountriesService(this.request);
        this.default = new DefaultService(this.request);
        this.financialData = new FinancialDataService(this.request);
        this.graphData = new GraphDataService(this.request);
        this.hsCodes = new HsCodesService(this.request);
        this.invitations = new InvitationsService(this.request);
        this.permissions = new PermissionsService(this.request);
        this.prodcom = new ProdcomService(this.request);
        this.publicAccess = new PublicAccessService(this.request);
        this.trade = new TradeService(this.request);
        this.tradeData = new TradeDataService(this.request);
        this.userInvitations = new UserInvitationsService(this.request);
        this.valueChainPermissions = new ValueChainPermissionsService(this.request);
    }
}

